import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header';


import { colors } from '../lib/styles';

const baseStyles = {
  container: {
    backgroundColor: colors.primaryHighlight,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    textAlign: 'center',
  },
  mainBody: {
    display: 'flex',
    height: '100%',
  },
};

class App extends Component {
  render() {
    const { user } = this.props;
    return (
      <div style={baseStyles.container}>
        <Header {...this.props} />
        <div style={baseStyles.mainBody}>hello {user.auth.email}</div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { user } = state;
  return { user };
}


export default connect(mapStateToProps)(App);
